import React from "react";
import "./Mainfeed.css";
import Sidebar from "../Sidebar/Sidebar";

export default function Mainfeed() {
  return (
    <div className="main-feed">
      {/* <Mainbar /> */}
      <Sidebar />
    </div>
  );
}
